import { ERRORS_MESSAGE } from "@lhd/constants";
import { APP_PART_TYPES } from "@lhd/features/Apps/AppForm/constants";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { Checkbox, Form, Input } from "antd";
import { FC } from "react";

type PropsType = {
  getFieldClassName?: (name: string) => string;
  appPart?: AppPartType;
};

const GeneralSetting: FC<PropsType> = ({ getFieldClassName, appPart }) => {
  const hiddenFiledRequired = [
    APP_PART_TYPES.PRIMARY_COMPANY_NAME,
    APP_PART_TYPES.COMPANY_LOCATION_SELECTION,
    APP_PART_TYPES.REPRESENTATIVE_SELECTION,
    APP_PART_TYPES.COMPANY_PHONE_NUMBER_SELECTION,
  ];
  return (
    <>
      <Form.Item
        label="フィールド名"
        name="name"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("name")}`}
      >
        <Input />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_hide_name"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>フィールド名を表示しない</Checkbox>
      </Form.Item>
      {hiddenFiledRequired.includes(appPart?.app_part_type as any) && (
        <Form.Item
          valuePropName="checked"
          name="is_required_field"
          style={{ marginBottom: "0.5rem" }}
        >
          <Checkbox>必須項目にする</Checkbox>
        </Form.Item>
      )}
      <Form.Item
        label="フィルードコード"
        name="field_code"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("field_code")}`}
      >
        <Input />
      </Form.Item>
    </>
  );
};

export default GeneralSetting;
